import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { Spring, animated } from 'react-spring';
import { AvForm } from 'availity-mobx-reactstrap-validation';
import * as clipboard from 'clipboard-polyfill';
import PubSub from 'pubsub-js';

import Button from 'js/components/common/Button';
import Title from './Title';
import Label from './Label';
import Input from './Input';
import CopyIcon from './CopyIcon';

function noop() {}

@observer
export default class CopyItem extends Component {
  input = React.createRef();

  @observable wasCopied = false;
  @action flagAsCopied = () => (this.wasCopied = true);

  selectText = () => {
    this.input.current.select();
    this.copyText();
    this.flagAsCopied();
  };

  copyText = () => {
    PubSub.publish('popup-text', 'Link copied!');
    (this.props.onCopy || noop)();
    clipboard
      .writeText(this.props.text)
      .then(this.flagAsCopied)
      .catch(() => {});
  };

  render() {
    const copyLabel = this.wasCopied ? 'Copied!' : 'Copy';
    return (
      <Spring
        native
        from={this.props.from || { opacity: 0, transform: 'translate3d(0,-2rem,0)' }}
        to={this.props.to || { opacity: 1, transform: 'translate3d(0,0rem,0)' }}
        config={this.props.config || { tension: 150 }}>
        {animation => (
          <animated.div style={animation}>
            <Title>{this.props.title}</Title>
            <AvForm>
              <Label>
                <Input
                  name="copy-text"
                  innerRef={this.input}
                  readOnly
                  type="text"
                  onClick={this.selectText}
                  value={this.props.text}
                />
                <CopyIcon />
              </Label>
              <Button onClick={this.copyText} flat>
                {copyLabel}
              </Button>
            </AvForm>
          </animated.div>
        )}
      </Spring>
    );
  }
}
